import {useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import Constants from "../Constants";


const BlogPage = ({catIds}) => {
    const [postCategory, setPostCategory] = useState([]);
    const [postSubCategory, setPostSubCategory] = useState([]);
    const [categoryMode, setCategoryMode] = useState(true);
    const [mainCategoryId, setMainCategoryId] = useState(0);
    const navigate = useNavigate();

    const changeRoute = (path) => {
        navigate(path);
    }

    useEffect(() => {
        const fetchCategories = async () => {
            const categories = await getCategories("categories");
            setPostCategory(categories.categories);
        }
        fetchCategories();
    }, []);

    const getCategories = async (appendUrl) => {
        let url = Constants.BaseUrl.concat(appendUrl);
        const categoryRes = await fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        });
        return await categoryRes.json();
    }


    return (
        <div className="container m-3 p-1">

            <div id="cat-panel" className="row justify-content-center mt-2">
                {postCategory.map((category, index) => (
                    <div key={category.id} className="col-md-3 g-3 font-link " id="card_parent">
                        <div className="card bg-light">
                            <div className="card-body text-center justify-content-center"
                                 onClick={async () => {
                                     if (!categoryMode && category.id === mainCategoryId) {
                                         setCategoryMode(true);
                                         return;
                                     }
                                     const subCategories = await getCategories("blog_sub_category");
                                     if (subCategories != null) {
                                         setPostSubCategory(subCategories.sub_categories);
                                         setCategoryMode(false);
                                         setMainCategoryId(category.id)
                                         // console.log('main category id = ' + category.id)
                                     }
                                 }}>
                                <img src={category.image_address} alt={category.title}
                                     className="img-fluid pe-auto w-75 h-50 pointer"/>
                                <h5 className="pointer">{category.title}</h5>
                            </div>
                            {(!categoryMode && category.id === mainCategoryId) &&
                            <ul id="sub-cat-panel" className="row text-center mx-auto mt-2 no-bullets">
                                {postSubCategory.map((category, index) => (
                                    <li key={category.id}
                                        className="btn btn-secondary text-light m-1 text-center font-link pointer"
                                        id="card_parent"
                                        onClick={() => {
                                            catIds([mainCategoryId, category.id]);
                                            // console.log('subId = ' + category.id + '  main cat id = ' + mainCategoryId);
                                            changeRoute("/posts_list");
                                        }}>
                                        <h6 className="fw-bolder text-center my-auto">{category.sub_cat_title}</h6>
                                    </li>
                                ))
                                }
                            </ul>}

                        </div>
                    </div>
                ))

                }

            </div>


        </div>
    )
}

export default BlogPage;